import { z } from "zod";

export const ZLoveLetter = z.object({
  type: z.literal("letter"),
  reason: z.string().startsWith("LL: "),
  code: z.number(),
  verbosity: z.number(),
});
export type LoveLetter = z.infer<typeof ZLoveLetter>;
